//
//


import { mapGetters, mapActions } from "vuex";
import { date } from "quasar";
import AQDropdown from "@/components/Generics/AQDropdown/AQDropdown.vue";
import AQDatetime from "@/components/Generics/AQDatetime/AQDatetime.vue";
import AQButton from "@/components/Generics/AQButton/AQButton.vue";
import AQInput from "@/components/Generics/AQInput/AQInput.vue";
import AQToast from "@/components/Generics/AQToast/AQToast.vue";
import AQTooltip from "@/components/Generics/AQTooltip/AQTooltip.vue";
import FabricSearch from "@/components/q-fabric-search.vue";
import AQChip from "@/components/Generics/AQChip/AQChip.vue";
import QAuModelPicker from "@/components/Generics/ModelPicker/qAuModelPicker.vue";
import { convertAndFormatTimeToLocal, setPluginIcon, eventBus } from "@/assets/js/appFunc";
import { formatDateAndTime } from "@/components/Diagrams/config/set-conditions";

import { TASK_STATUSES } from "../ReportsTasksAndInstances/ReportsTable.const";
import {
    TASKS_STATUS, TASKS_PRIORITY, TASKS_INSTANCE_STATUS, OPERATORS_VALUES, OPERATORS_BOOLEAN_VALUES,
    OPERATORS_ALL_VALUES, BOOLEAN_VALUES, REFS_TO_RESET, REPORTS_FILTERS_DEFAULT
} from "./constants";
import CustomFiltersFields from "./CustomFiltersFields.vue";

export default {
    name: "SearchFiltersReports",
    components: {
        AQDropdown,
        AQDatetime,
        AQButton,
        AQInput,
        AQChip,
        QAuModelPicker,
        AQToast,
        AQTooltip,
        FabricSearch,
        CustomFiltersFields
    },
    props: {
        filterDetails: { type: Object, default: () => {} },
        hideCollapse: { type: Boolean, default: false },
        resetStatus: { type: Boolean, default: false },
        favoriteFilters: { type: Array, default: () => [] },
        filtersList: { type: Array, default: () => [] },
        externalData: { type: Object, default: () => {} },
        selectedAchoredPlugin: { type: Object, default: () => {} },
        disableEnterEv: { type: Boolean, default: false },
        isOpened: { type: Boolean, default: false },
        readonly: { type: Boolean, default: false },
        statisticsOpened: { type: Boolean, default: false },
        selectedProcess: { type: Object, default: () => ({}) },
        resetFilters: { type: Boolean, default: false },
        showFavFilters: { type: Boolean, default: false },
        refreshDataWhenTabChanges: { type: Boolean, default: false },
        pageType: { type: String, default: "" },
        processId: { type: String, default: "" },
        perspectiveInvisibleTasks: { type: Array, default: () => [] },
        diagramLoaded: { type: Boolean, default: false }
    },
    data() {
        return {
            searchTitle: this.$t("tasks.search"),
            filtersBtn: this.$t("diagrams.thresholds.filters"),
            saveAsBtn: this.$t("mainPage.saveAs"),
            selectAttributes: this.$t("dashboard.selectAttributes"),
            usedFilterTitle: this.$t("dashboard.usedFilterTitle"),
            taskStatuses: TASK_STATUSES,
            windowWidth: window.innerWidth,
            refsToReset: REFS_TO_RESET,
            currentSelectedAnchoredData: {},
            noStatusReset: false,
            filterObject: {
                search: "",
                statusesMod: [],
                instanceMod: [],
                fromDateTime: "",
                toDateTime: "",
                activityMod: "",
                priorityMod: [],
                localDataModel: []
            },
            temporaryFilterObject: {
                search: "",
                statusesMod: [],
                instanceMod: [],
                fromDateTime: "",
                toDateTime: "",
                activityMod: "",
                priorityMod: [],
                localDataModel: []
            },
            search: "",
            reportsDefaultFilters: REPORTS_FILTERS_DEFAULT,
            dataModelErrors: [],
            dataModelType: ["string", "integer", "decimal"],
            usersGroupsMod: [],
            temporaryUsersGroupsMod: [],
            selection: [],
            fromDateTime: "",
            toDateTime: "",
            dateTime: "datetime",
            dateTimeFormat: "DD.MM.YYYY HH:mm",
            timeFormat: "HH:mm",
            dateFormat: "DD.MM.YYYY",
            statusesData: TASKS_STATUS,
            priorityData: TASKS_PRIORITY,
            dataInstanceStatus: TASKS_INSTANCE_STATUS,
            optionsBehaviour: OPERATORS_VALUES,
            optionsBooleanBehaviour: OPERATORS_BOOLEAN_VALUES,
            optionsLongBehaviour: OPERATORS_ALL_VALUES,
            optionsBoolean: BOOLEAN_VALUES,
            allowTriggerEnter: true,
            filterName: "",
            savedfilterName: "",
            searchValue: "",
            activitiesData: [],
            activitiesDataFromCall: [],
            enablePagination: true,
            usersGroupsDataOptions: [],
            usersGroupsPayload: {
                searchValue: "",
                processDefinitionId: "",
                pagination: true,
                fromProcessInspector: true,
                pageNumber: 0,
                pageSize: 50
            },
            payload: {
                taskAndInstanceFilterModel: {
                    applicationId: "",
                    processDefinitionId: "",
                    creationDateFrom: "",
                    creationDateTo: "",
                    dataModelFields: [],
                    activityIds: [],
                    groupIds: [],
                    priorities: [],
                    taskStatus: [],
                    instanceStatuses: [],
                    userIds: []
                }
            },
            temporaryPayload: {},
            allowResetDiagram: true,
            saveFilterObj: {
                name: "",
                interfaceName: "reports",
                searchModel: {}
            },
            shareFilterTooltip: this.$t("reports.copyFilterInfo"),
            showDataModel: false,
            arrayDataModel: [],
            saveFilterState: false,
            checkAlfaNum: false,
            isNotInteger: false,
            filterData: {},
            errorMessage: "",
            emptyFilterName: false,
            duplicateName: false,
            canBeSaved: false,
            showFilterName: false,
            tempoUG: [],
            showFavoriteIcon: false,
            resetStatusesData: false,
            resetInstancesData: false,
            resetAssigneesData: false,
            resetPriorityData: false,
            optionsMenu: "",
            filterId: "",
            allActivities: [],
            selectedActivity: null,
            filterSavedId: "",
            checkName: true,
            searchTriggered: false,
            clearAction: false,
            loadFilterAction: false,
            displayedFilters: [],
            resetFiltersObject: {
                resetActivitesData: false,
                resetStatusesData: false
            },
            dmFilterError: false,
            activityFromCall: [],
            processIdActivities: "",
            groupFilterIds: [],
            userFilterIds: [],
            dmToHide: [],
            perspectiveWasLoaded: false,
            inputAllActivities: [],
            resetActivityField: false,
            incomePerspectiveDataModelKeys: [],
            incomePerspectiveDataModel: [],
            activityToSelect: null
        };
    },
    computed: {
        ...mapGetters("main", ["getCurrentApplicationId"]),
        ...mapGetters("perspectiveBuilder", ["getPerspectiveId"]),
        ...mapGetters("diagrams", ["selectedPluginUuid"]),
        ...mapGetters("reports", ["getSelectedProcessReports"]),
        getCurrentSelectedProcess() {
            return this.getSelectedProcessReports[this.pageType];
        },
        displayFilters() {
            return this.pageType !== "reports" && this.externalData ? this.externalData.canSaveFilters : true;
        },
        displayDataModel() {
            return this.pageType !== "reports" && this.externalData ? this.externalData.canAddDM : true;
        },
        displaySaveAs() {
            return this.pageType === "reports" ? this.canBeSaved : this.canBeSaved && this.externalData?.canSaveFilters;
        },
        displayClearFilters() {
            return this.pageType !== "reports" ? this.noFiltersChecked : true;
        },
        readOnlyState() {
            return !this.pageType;
        },
        noFiltersChecked() {
            let isEmpty = false;
            if (this.externalData && this.externalData.fields.length) {
                isEmpty = this.externalData.fields.some(elem => {
                    let inLayout;
                    if (elem.invisibleToUser) {
                        inLayout = false;
                    } else {
                        inLayout = elem.visible;
                    }
                    return inLayout;
                });
            }
            return isEmpty;
        },
        searchLabel() {
            return this.pageType !== "reports" && !this.noFiltersChecked ? this.$t("api.refresh") : this.$t("tasks.search");
        },
        checkIfEnter() {
            return !this.saveFilterState && !this.disableEnterEv && this.allowTriggerEnter;
        },
        errorNameMessage() {
            let message = "";
            if (this.emptyFilterName) {
                message = this.$t("dashboard.emptyNameFilter");
            } else if (this.duplicateName) {
                message = this.$t("dashboard.duplicateName");
            }
            return message;
        }
    },
    watch: {
        filterData: {
            handler(data) {
                this.setDataToSearch(data);
            },
            deep: true
        },
        resetFiltersObject: {
            handler(value) {
                if (value.resetActivitesData) {
                    this.displayedFilters = this.displayedFilters.map(filter => {
                        if (filter.value === "activity") {
                            filter.fieldValue[0].value = "";
                        }
                        return filter;
                    });
                }
                if (value.resetStatusesData) {
                    this.displayedFilters = this.displayedFilters.map(filter => {
                        if (filter.value === "taskStatus") {
                            filter.fieldValue[0].value = [];
                        }
                        return filter;
                    });
                }
            },
            deep: true
        },
        selectedAchoredPlugin: {
            handler(newValue) {
                if (newValue && newValue.hasOwnProperty("pluginId")) {
                    this.$emit("openSearchContainer", true);
                    const timeoutToLoad = this.isOpened ? 0 : 350;
                    setTimeout(() => {
                        this.displayedFilters = this.displayedFilters.map(filter => {
                            if (filter.value === "taskStatus") {
                                filter.fieldValue[0].value = this.setDefinedStatus(newValue).length ? [this.setDefinedStatus(newValue)[0].value] : [];
                            }
                            return filter;
                        });
                    }, timeoutToLoad);
                }
                const { anchorUuid } = this.currentSelectedAnchoredData;
                const { anchorPosition } = this.currentSelectedAnchoredData;
                const checkAnchorUuid = !newValue.anchorUuid && anchorUuid && this.selectedPluginUuid && anchorUuid === this.selectedPluginUuid;
                const checkValue = checkAnchorUuid || (!anchorUuid && newValue.anchorUuid);

                if (checkValue || (anchorUuid && newValue.anchorUuid
                    && (anchorUuid === newValue.anchorUuid)
                    && (anchorPosition !== newValue.anchorPosition))) {
                    this.temporaryPayload.taskAndInstanceFilterModel.taskStatus = this.setDefinedStatus(newValue, true);
                    const activityData = newValue && newValue.anchorUuid ? newValue.anchorUuid : (anchorUuid || this.selectedPluginUuid);
                    this.temporaryPayload.taskAndInstanceFilterModel.activityIds = activityData ? [activityData] : [];
                    this.$emit("resetDiagramStatus", this.temporaryPayload);
                    this.allowResetDiagram = false;
                } else {
                    this.allowResetDiagram = true;
                }
                this.currentSelectedAnchoredData = newValue;
            },
            deep: true
        },
        resetStatus: {
            handler(value) {
                if (value) {
                    if (this.noStatusReset) {
                        this.noStatusReset = false;
                    } else {
                        this.resetFiltersObject.resetStatusesData = true;
                        setTimeout(() => {
                            this.resetFiltersObject.resetStatusesData = false;
                        }, 0);
                    }
                }
            }
        },
        favoriteFilters: {
            handler(value) {
                this.showFavoriteIcon = !!value.find(filter => filter.id === this.filterId || filter.name === this.savedfilterName);
            }
        },
        savedfilterName: {
            handler(value) {
                this.showFavoriteIcon = (this.localFavoriteName === value);
            }
        },
        refreshDataWhenTabChanges: {
            handler(value) {
                if (value && !this.statisticsOpened && this.getCurrentSelectedProcess.id) { this.processIdActivities = this.getCurrentSelectedProcess.id; }
            }
        },
        resetFilters: {
            handler(val) {
                if (val && this.pageType === "reports") {
                    this.clearFilters();
                }
            }
        },
        pageType: {
            handler(value) {
                this.displayedFilters = value === "reports" ? [...this.reportsDefaultFilters] : [];
            },
            immediate: true
        },
        filtersList: {
            handler(value) {
                this.showFilterName = !!value.find(filter => filter.name === this.savedfilterName);
            }
        },
        filterDetails: {
            handler(value) {
                this.setFilterPreferences(value);
                this.checkToSearchData();
                this.updateCurrentRoute();
            },
            deep: true
        },
        selectedProcess: {
            handler(value) {
                if (value && value.id) {
                    this.processIdActivities = value.id;
                    if (this.$route.query.filterId && this.$route.query.processDefinitionId === this.selectedProcess.id) {
                        this.$emit("openSearchContainer", true);
                        const payload = {
                            id: this.$route.query.filterId,
                            processDefinitionId: this.$route.query.processDefinitionId,
                            perspectiveCase: this.pageType === "searchPerspectives",
                            perspectiveId: this.getPerspectiveId,
                            appId: this.getCurrentApplicationId
                        };
                        this.getFilter(payload).then(
                            data => {
                                this.setFilterPreferences(data);
                                this.checkToSearchData();
                                eventBus.$emit("resetLoadFilter");
                            },
                            () => {
                                this.checkToSearchData();
                                this.$toast.showNotify({
                                    type: "error",
                                    message: this.$t("liveView.tasksInstances.filterNotFound")
                                });
                            }
                        ).catch(() => {
                            this.$toast.showNotify({
                                type: "error",
                                code: "filter-loadFail",
                                message: this.$t("searchPerspectives.loadFilterError")
                            });
                        });
                    }
                }
            }
        },
        selectedPluginUuid: {
            handler(value) {
                if (!this._inactive) {
                    if (value && !this.statisticsOpened) {
                        if (this.$route.name === "reports") {
                            this.$emit("openSearchContainer", true);
                        }
                        const timeoutToLoad = this.isOpened ? 0 : 350;
                        this.temporaryPayload.taskAndInstanceFilterModel.activityIds = [value];
                        setTimeout(() => {
                            this.displayedFilters = this.displayedFilters.map(elem => {
                                if (elem.value === "activity") {
                                    this.filterObject.activityMod = value;
                                    elem.fieldValue[0].value = value;
                                }
                                return elem;
                            });
                        }, timeoutToLoad);
                    } else {
                        this.temporaryPayload.taskAndInstanceFilterModel.activityIds = [];
                        this.currentSelectedAnchoredData = {};
                    }
                    if (this.allowResetDiagram) {
                        this.resetFiltersObject.resetActivitesData = !this.searchTriggered;
                        this.resetFiltersObject.resetStatusesData = !this.searchTriggered || this.clearAction;
                        if (!this.searchTriggered) {
                            this.temporaryPayload.taskAndInstanceFilterModel.taskStatus = this.setDefinedStatus(this.selectedAchoredPlugin, true);
                        }
                        if (this.pageType === "searchPerspectives" && this.perspectiveInvisibleTasks && this.perspectiveInvisibleTasks.length) {
                            this.temporaryPayload.taskAndInstanceFilterModel.taskStatus = this.perspectiveInvisibleTasks;
                        }
                        this.$emit("resetDiagramStatus", this.temporaryPayload);
                    } else {
                        this.allowResetDiagram = true;
                    }
                    setTimeout(() => {
                        this.searchTriggered = false;
                        this.resetFiltersObject.resetStatusesData = false;
                        this.resetFiltersObject.resetActivitesData = false;
                        this.clearAction = false;
                    }, 0);
                }
            }
        },
        usersGroupsMod: {
            handler(value) {
                let result = [];
                if (value.length === this.temporaryUsersGroupsMod.length) {
                    result = this.temporaryUsersGroupsMod.filter(l1 => this.temporaryUsersGroupsMod.some(l2 => l1.value === l2.value));
                }
                this.showFilterName = !!result.length;
            }
        },
        filterObject: {
            handler(value) {
                if (this.filterDetails) {
                    if (JSON.stringify(value) !== JSON.stringify(this.temporaryFilterObject)) {
                        this.showFilterName = false;
                    } else if (this.checkName) {
                        this.showFilterName = true;
                    }
                }
            },
            deep: true
        },
        externalData: {
            handler(value) {
                if (value && value.fields.length) {
                    this.displayedFilters = JSON.parse(JSON.stringify(value.fields));
                    this.displayedFilters = this.displayedFilters.map(elem => {
                        if (elem.hasOwnProperty("className")) {
                            elem.canBeDeleted = false;
                        }
                        return elem;
                    });
                    const onlyDM = this.displayedFilters.filter(elem => elem.hasOwnProperty("className"));
                    this.incomePerspectiveDataModelKeys = [];
                    this.incomePerspectiveDataModel = [];
                    this.dmToHide = onlyDM.map(elem => {
                        this.incomePerspectiveDataModelKeys.push(elem.value);
                        this.incomePerspectiveDataModel.push(elem);
                        const [, dmPath] = elem.value.split("m_");
                        return dmPath;
                    });
                    if (this.pageType) {
                        this.setDataToLoad(this.displayedFilters);
                    }
                }
            },
            immediate: true,
            deep: true
        },
        diagramLoaded: {
            handler(newValue) {
                if (newValue && this.activityToSelect) {
                    this.activityToSelect = null;
                    this.searchItems();
                }
            }
        }
    },
    mounted() {
        const { query } = this.$route;
        if (Object.keys(query).length && !query.filterId) {
            const getDatafromQuery = () => {
                const newData = {};
                const exceptionList = ["activityIds", "groupIds", "instanceStatuses",
                    "priorities", "taskStatus", "userIds"
                ];
                exceptionList.forEach(prop => {
                    newData[prop] = query[prop] ? query[prop].split(",") : [];
                });
                return { ...query, ...newData };
            };
            const getDataModel = () => {
                let dataModelToReturn = [];
                if (query.dataModelFields) {
                    const getQueryDataModel = () => ((query.dataModelFields || []).map(item => JSON.parse(decodeURIComponent(item))));

                    dataModelToReturn = Array.isArray(query.dataModelFields) ? getQueryDataModel() : [JSON.parse(decodeURIComponent(query.dataModelFields))];
                }
                return dataModelToReturn;
            };
            const dataFromQuery = { ...getDatafromQuery(), ...{ dataModelFields: getDataModel() } };
            const finalData = { searchModel: {
                searchTerm: dataFromQuery.search || "",
                taskAndInstanceFilterModel: dataFromQuery
            } };

            const getAvailableQuery = () => {
                const exceptionList = ["activityIds", "groupIds", "instanceStatuses",
                    "priorities", "taskStatus", "userIds"
                ];
                const filterList = {
                    search: "search",
                    activity: "activityIds",
                    taskStatus: "taskStatus",
                    instanceStatus: "instanceStatuses",
                    fromDate: "creationDateFrom",
                    toDate: "creationDateTo",
                    assignees: "userIds",
                    taskPriority: "priorities"
                };
                const newData = {};
                let removeGroupIds;
                this.displayedFilters.forEach(({ value, visible }) => {
                    if (visible) {
                        newData[filterList[value]] = dataFromQuery[filterList[value]];
                    } else if (value === "assignees") {
                        removeGroupIds = true;
                        newData.groupIds = [];
                        newData.userIds = [];
                    } else {
                        newData[filterList[value]] = exceptionList.includes(filterList[value]) ? [] : "";
                    }
                });

                newData.dataModelFields = this.displayDataModel ? dataFromQuery.dataModelFields : [];
                newData.groupIds = removeGroupIds ? [] : (dataFromQuery.groupIds || []);
                return {
                    searchModel: {
                        searchTerm: newData.search || "",
                        taskAndInstanceFilterModel: newData
                    }
                };
            };

            this.$nextTick(() => {
                this.getFilterData(this.pageType === "searchPerspectives" ? getAvailableQuery() : finalData);

                if (this.filterObject.activityMod) {
                    this.activityToSelect = this.filterObject.activityMod;
                } else {
                    this.searchItems();
                }
            });
        }
        this.temporaryPayload = { searchTerm: "", ...JSON.parse(JSON.stringify(this.payload)) };
        this.temporaryPayload.taskAndInstanceFilterModel.applicationId = this.getCurrentApplicationId;
        this.temporaryPayload.taskAndInstanceFilterModel.processDefinitionId = this.selectedProcess.id;
        this.temporaryPayload.taskAndInstanceFilterModel.instanceStatuses = [];

        this.$root.$on("activeEnterEv", (data) => {
            if (data) {
                this.setActionOnEnter();
            } else {
                this.removeActionOnEnter();
            }
        });

        eventBus.$on("searchTasksAndInstances", data => {
            if (!this._inactive) {
                this.searchTasksAndInstances(data);
            }
        });
        eventBus.$on("disableEventEnter", data => {
            this.allowTriggerEnter = !data;
        });
        eventBus.$on("perspectiveLoaded", () => {
            this.perspectiveWasLoaded = true;
        });
    },
    methods: {
        ...mapActions("reports", ["saveReportsFilter", "generateFilterLink", "getFilter"]),
        convertAndFormatTimeToLocal,
        setPluginIcon,
        setDataToSearch(data) {
            if (data.type === "search") {
                this.filterObject.search = data.value;
                this.displayedFilters = this.displayedFilters.map(filter => {
                    if (filter.value === "search") {
                        filter.fieldValue[0].value = data.value;
                    }
                    return filter;
                });
            } else if (data.type === "statuses") {
                this.filterObject.statusesMod = [...data.value];
            } else if (data.type === "instance") {
                this.filterObject.instanceMod = [...data.value];
            } else if (data.type === "priority") {
                this.filterObject.priorityMod = [...data.value];
            } else if (data.type === "from") {
                this.displayedFilters = this.displayedFilters.map(filter => {
                    if (filter.value === "fromDate") {
                        filter.fieldValue[0].value = data.value;
                    }
                    return filter;
                });
                this.filterObject.fromDateTime = data.value;
            } else if (data.type === "to") {
                this.displayedFilters = this.displayedFilters.map(filter => {
                    if (filter.value === "toDate") {
                        filter.fieldValue[0].value = data.value;
                    }
                    return filter;
                });
                this.filterObject.toDateTime = data.value;
            } else if (data.type === "activity") {
                this.filterObject.activityMod = data.value;
            } else if (data.type === "assignee") {
                this.groupFilterIds = [...data.groups];
                this.userFilterIds = [...data.users];
                this.usersGroupsMod = [...data.users, ...data.groups];
            } else if (data.type === "dataModel") {
                this.filterObject.localDataModel = this.filterObject.localDataModel.map(elem => {
                    if (elem.formatted === data.key) {
                        elem.fieldValue[0].value = data.value;
                        elem.operator = data.operator;
                    }
                    return elem;
                });
            }
        },
        setDataToLoad(filters) {
            if (filters && filters.length) {
                const filtersKeyList = {
                    search: "search",
                    taskStatus: "statusesMod",
                    instanceStatus: "instanceMod",
                    taskPriority: "priorityMod",
                    fromDate: "fromDateTime",
                    toDate: "toDateTime",
                    activity: "activityMod"
                };
                filters.forEach(elem => {
                    if (!elem.hasOwnProperty("className")) {
                        const [filterData] = elem.fieldValue;
                        if (elem.value === "assignees") {
                            this.groupFilterIds = elem.visible ? [...filterData.value] : [];
                            this.userFilterIds = elem.visible ? [...elem.fieldValue[1].value] : [];
                            this.usersGroupsMod = [...elem.fieldValue[1].value, ...filterData.value];
                        } else if (elem.visible) {
                            this.filterObject[filtersKeyList[elem.value]] = Array.isArray(filterData.value) ? [...filterData.value] : filterData.value;
                        } else {
                            this.filterObject[filtersKeyList[elem.value]] = Array.isArray(filterData.value) ? [] : "";
                        }
                    }
                });
            }
            const dataModelFilters = filters.filter(elem => elem.hasOwnProperty("className") && elem.visible);
            this.filterObject.localDataModel = dataModelFilters.map(elem => {
                elem.formatted = elem.value;
                return elem;
            });
        },
        setActionOnEnter() {
            window.addEventListener("keyup", this.actionOnEnter);
        },
        removeActionOnEnter() {
            window.removeEventListener("keyup", this.actionOnEnter);
        },
        actionOnEnter(event) {
            event.preventDefault();
            if (event.keyCode === 13 && this.checkIfEnter) {
                if (this.$refs.reportSearchRef && this.$refs.reportSearchRef.$refs.AQSearch && this.$refs.reportSearchRef.$refs.AQSearch.$refs.AQInput) {
                    this.$refs.reportSearchRef.$refs.AQSearch.$refs.AQInput.blur();
                }
                this.checkToSearchData();
            }
        },
        getFilterData(value) {
            this.filterObject.search = value.searchModel.searchTerm || "";
            this.temporaryFilterObject.search = this.filterObject.search;

            this.filterObject.fromDateTime = value.searchModel.taskAndInstanceFilterModel.creationDateFrom;
            this.temporaryFilterObject.fromDateTime = this.filterObject.fromDateTime;

            this.filterObject.toDateTime = value.searchModel.taskAndInstanceFilterModel.creationDateTo;
            this.temporaryFilterObject.toDateTime = this.filterObject.toDateTime;

            if (value.searchModel.taskAndInstanceFilterModel.taskStatus.length) {
                this.filterObject.statusesMod = [...value.searchModel.taskAndInstanceFilterModel.taskStatus];
                this.temporaryFilterObject.statusesMod = [...this.filterObject.statusesMod];
                const activityList = value.searchModel.taskAndInstanceFilterModel.activityIds;
                if (activityList.length && activityList[0] !== this.selectedPluginUuid) {
                    this.noStatusReset = true;
                }
                eventBus.$emit("selectStatusFromDDL");
            } else {
                this.resetFiltersObject.resetStatusesData = true;
                this.filterObject.statusesMod = [];
                this.temporaryFilterObject.statusesMod = [];
                this.noStatusReset = false;
            }

            if (value.searchModel.taskAndInstanceFilterModel.activityIds.length) {
                [this.filterObject.activityMod] = value.searchModel.taskAndInstanceFilterModel.activityIds;
                this.temporaryFilterObject.activityMod = this.filterObject.activityMod;
            } else {
                this.resetFiltersObject.resetActivitesData = true;
                this.filterObject.activityMod = "";
                this.temporaryFilterObject.activityMod = "";
            }

            if (value.searchModel.taskAndInstanceFilterModel.instanceStatuses.length) {
                this.filterObject.instanceMod = [...value.searchModel.taskAndInstanceFilterModel.instanceStatuses];
                this.temporaryFilterObject.instanceMod = [...this.filterObject.instanceMod];
            } else {
                this.resetInstancesData = true;
                this.filterObject.instanceMod = [];
                this.temporaryFilterObject.instanceMod = [];
            }

            if (value.searchModel.taskAndInstanceFilterModel.priorities.length) {
                this.filterObject.priorityMod = [...value.searchModel.taskAndInstanceFilterModel.priorities];
                this.temporaryFilterObject.priorityMod = [...this.filterObject.priorityMod];
            } else {
                this.resetPriorityData = true;
                this.temporaryFilterObject.priorityMod = [];
                this.filterObject.priorityMod = [];
            }

            this.groupFilterIds = [...value.searchModel.taskAndInstanceFilterModel.groupIds];
            this.userFilterIds = [...value.searchModel.taskAndInstanceFilterModel.userIds];

            this.filterObject.localDataModel = [];
            this.filterObject.localDataModel = value.searchModel.taskAndInstanceFilterModel.dataModelFields.map(elem => {
                const [className, attributeName] = elem.fieldName.split(".").splice(-2);
                const dmField = this.displayedFilters.find(dm => dm.formatted === elem.fieldName);
                const paramsToReturn = {
                    className: className.substring(0, 2) === "m_" ? className.split("m_")[1] : className,
                    fieldValue: [{
                        value: elem.value
                    }],
                    invisibleToUser: dmField ? dmField.invisibleToUser : false,
                    label: attributeName,
                    lockOperator: false,
                    operator: elem.operator,
                    formatted: elem.fieldName,
                    type: elem.fieldType.toLowerCase(),
                    visible: true,
                    canBeDeleted: dmField ? dmField.canBeDeleted : true
                };
                return paramsToReturn;
            });
            this.temporaryFilterObject.localDataModel = JSON.parse(JSON.stringify(this.filterObject.localDataModel));

            const filtersKeyList = {
                search: "search",
                taskStatus: "statusesMod",
                instanceStatus: "instanceMod",
                taskPriority: "priorityMod",
                fromDate: "fromDateTime",
                toDate: "toDateTime",
                activity: "activityMod"
            };
            this.displayedFilters = this.displayedFilters.filter(elem => !elem.canBeDeleted);
            this.displayedFilters = this.displayedFilters.map(elem => {
                if (!elem.hasOwnProperty("className")) {
                    if (elem.value === "assignees") {
                        elem.fieldValue[0].value = [...value.searchModel.taskAndInstanceFilterModel.groupIds];
                        elem.fieldValue[1].value = [...value.searchModel.taskAndInstanceFilterModel.userIds];
                        this.usersGroupsMod = [...elem.fieldValue[0].value, ...elem.fieldValue[1].value];
                        this.temporaryUsersGroupsMod = [...this.usersGroupsMod];
                    } else {
                        elem.fieldValue[0].value = Array.isArray(elem.fieldValue[0].value)
                            ? [...this.filterObject[filtersKeyList[elem.value]]] : this.filterObject[filtersKeyList[elem.value]];
                    }
                } else {
                    const dmField = this.filterObject.localDataModel.find(dm => dm.formatted === elem.formatted);
                    if (dmField) {
                        elem.fieldValue[0].value = dmField.fieldValue[0].value;
                        elem.operator = dmField.operator;
                    }
                }
                return elem;
            });
            const dmFilters = this.displayedFilters.filter(elem => elem.hasOwnProperty("className") && !elem.invisibleToUser);
            const resultsToAdd = this.filterObject.localDataModel.filter(elem => dmFilters.findIndex(val => val.formatted === elem.formatted) === -1);
            this.displayedFilters = [...this.displayedFilters, ...resultsToAdd];
        },
        setFilterPreferences(value) {
            this.showFilterName = true;
            this.checkName = true;
            this.filterId = value.id;
            this.filterSavedId = this.filterId;
            this.showFavoriteIcon = value.favorite;
            this.savedfilterName = value.name;
            this.canBeSaved = false;
            this.saveFilterState = false;
            this.loadFilterAction = true;
            this.localFavoriteName = this.showFavoriteIcon ? this.savedfilterName : "";
            this.getFilterData(value);
        },
        checkIfFilterHasValues(obj) {
            let hasValues = false;
            if ((Object.keys(obj).every((x) => obj[x] === "" || obj[x]?.length === 0) === false) || this.usersGroupsMod.length) {
                hasValues = true;
            }
            return hasValues;
        },
        resetAllFilters() {
            this.displayedFilters = this.displayedFilters.map(elem => {
                if (!elem.invisibleToUser) {
                    if (elem.value === "taskStatus" || elem.value === "instanceStatus" || elem.value === "taskPriority") {
                        elem.fieldValue[0].value = [];
                    } else if (elem.value === "assignees") {
                        elem.fieldValue[0].value = [];
                        elem.fieldValue[1].value = [];
                        this.userFilterIds = [];
                        this.groupFilterIds = [];
                        this.usersGroupsMod = [];
                    } else {
                        elem.fieldValue[0].value = "";
                        if (elem.value === "activity") {
                            this.filterObject.activityMod = "";
                            this.resetActivityField = true;
                            const dataToSend = {
                                uuid: null,
                                id: null,
                                plvType: false
                            };
                            this.$emit("pluginSelected", dataToSend);
                        }
                        setTimeout(() => {
                            this.resetActivityField = false;
                        }, 0);
                    }
                }
                return elem;
            });
        },
        setDefinedStatus(data, valueOnly) {
            let returnData = [];
            if (data && data.anchorPosition) {
                const statVar = this.taskStatuses[data.anchorPosition];
                returnData = valueOnly ? [statVar] : this.statusesData.filter(elem => elem.value === this.taskStatuses[data.anchorPosition]);
            }
            return returnData;
        },
        getSearchValue(value) {
            this.searchValue = value;
        },
        saveFilterLink() {
            const payload = {
                id: this.filterSavedId,
                processDefinitionId: this.selectedProcess.id,
                pageType: this.pageType,
                perspectiveCase: this.pageType === "searchPerspectives",
                perspectiveId: this.getPerspectiveId,
                appId: this.getCurrentApplicationId
            };
            this.generateFilterLink(payload).then(link => {
                navigator.clipboard
                    .writeText(link)
                    .then(() => {
                        this.shareFilterTooltip = this.$t("reports.succesCopyFilter");
                    });
            });
        },
        resetCopyTooltip() {
            this.shareFilterTooltip = this.$t("reports.copyFilterInfo");
        },
        showDataModelField() {
            const visibleFields = this.filterObject.localDataModel.filter(elem => !elem.invisibleToUser);
            this.selection = visibleFields.map(elem => elem.formatted);
            this.showDataModel = true;
        },
        dataToSend() {
            this.payload.searchTerm = this.filterObject.search;
            this.payload.page = 0;
            this.payload.size = 10;
            this.payload.taskAndInstanceFilterModel.taskStatus = [...this.filterObject.statusesMod];

            this.payload.taskAndInstanceFilterModel.activityIds = [];
            this.selectedActivity = null;
            this.payload.taskAndInstanceFilterModel.activityIds = this.filterObject.activityMod ? [this.filterObject.activityMod] : [];

            this.payload.taskAndInstanceFilterModel.instanceStatuses = [...this.filterObject.instanceMod];

            this.payload.taskAndInstanceFilterModel.creationDateFrom = this.filterObject.fromDateTime;
            this.payload.taskAndInstanceFilterModel.creationDateTo = this.filterObject.toDateTime;

            this.payload.taskAndInstanceFilterModel.priorities = [...this.filterObject.priorityMod];

            this.payload.taskAndInstanceFilterModel.userIds = [...this.userFilterIds];
            this.payload.taskAndInstanceFilterModel.groupIds = [...this.groupFilterIds];

            this.payload.taskAndInstanceFilterModel.dataModelFields = this.filterObject.localDataModel.map(elem => {
                let isNumber = null;
                let modelValue = elem.fieldValue[0].value;
                const attributeType = elem.type.toUpperCase();
                if (attributeType === "INTEGER") {
                    isNumber = "NUMBER";
                }
                if (elem.type === "date" || elem.type === "datetime" || elem.type === "time") {
                    let dataValue = modelValue;
                    if (elem.type === "time" && !date.isValid(modelValue)) {
                        dataValue = `2020-07-07T${modelValue}`;
                    }
                    modelValue = formatDateAndTime(elem.type, dataValue).replace(/'/g, "");
                } else if (elem.type === "string") {
                    modelValue = modelValue.trim();
                }

                return {
                    fieldName: elem.formatted, fieldType: isNumber || attributeType, operator: elem.operator, value: modelValue
                };
            });
            this.payload.taskAndInstanceFilterModel.applicationId = this.getCurrentApplicationId;
            this.payload.taskAndInstanceFilterModel.processDefinitionId = this.selectedProcess.id;
        },
        checkToSearchData(noPluginSelection) {
            if (!this.dmFilterError) {
                this.dataToSend();
                this.allowResetDiagram = false;
                this.$emit("searchAndFiltersPayload", this.payload);
                this.clearAction = false;
                this.currentSelectedAnchoredData = {};
                this.temporaryPayload = JSON.parse(JSON.stringify(this.payload));

                let pluginToSave = [];
                if (this.filterObject.activityMod) {
                    pluginToSave = this.activityFromCall.filter(elem => elem.activityId === this.filterObject.activityMod);
                }

                if (!noPluginSelection) {
                    const dataToSend = {
                        uuid: pluginToSave.length ? pluginToSave[0].activityId : null,
                        id: pluginToSave.length ? pluginToSave[0].activityType : null,
                        plvType: false
                    };
                    this.$emit("pluginSelected", dataToSend);
                    const hasValues = this.checkIfFilterHasValues(this.filterObject);
                    this.canBeSaved = !this.loadFilterAction && hasValues && !this.perspectiveWasLoaded;
                }
            }
        },
        searchItems() {
            this.searchTriggered = true;
            this.$root.$emit("clearFilters", false);
            this.loadFilterAction = false;
            if (this.perspectiveWasLoaded) {
                this.checkToSearchData(false);
                this.perspectiveWasLoaded = false;
            } else {
                this.checkToSearchData();
            }
        },
        updateCurrentRoute() {
            const { searchTerm, taskAndInstanceFilterModel } = this.payload;
            const getDataModel = (v) => (v.map(item => encodeURIComponent(JSON.stringify(item))));
            const getDataForQuery = () => {
                const newQuery = {};
                Object.entries(taskAndInstanceFilterModel).forEach(([key, value]) => {
                    if (!["applicationId", "processDefinitionId"].includes(key) && value && value.length) {
                        newQuery[key] = value.toString();
                    }
                });
                return newQuery;
            };
            const { dataModelFields } = taskAndInstanceFilterModel;
            const query = { ...(searchTerm ? { search: searchTerm } : {}),
                ...getDataForQuery(),
                ...(dataModelFields?.length ? { dataModelFields: getDataModel(dataModelFields) } : {}) };

            const { path, fullPath } = this.$route;
            const checkMatchRoute = this.$router.match({ path, query });

            if (fullPath !== checkMatchRoute.fullPath) {
                this.$router.replace({ query });
            }
        },
        searchForFilters() {
            this.searchItems();
            this.updateCurrentRoute();
        },
        clearFilters() {
            this.clearAction = true;
            if (this.pageType === "searchPerspectives") {
                this.displayedFilters = this.displayedFilters
                    .filter(elem => !elem.hasOwnProperty("className") || (elem.hasOwnProperty("className") && !elem.canBeDeleted));
                this.displayedFilters = this.displayedFilters.map(elem => {
                    if (elem.hasOwnProperty("className")) {
                        elem.fieldValue[0].value = elem.invisibleToUser ? elem.fieldValue[0].value : "";
                        elem.operator = elem.lockOperator || elem.invisibleToUser ? elem.operator : "EQUAL";
                    }
                    return elem;
                });
                this.filterObject.localDataModel = this.filterObject.localDataModel
                    .filter(ldm => this.displayedFilters.some(ddm => ldm.formatted === ddm.formatted));

                this.filterObject.localDataModel = this.filterObject.localDataModel.map(dm => {
                    if (!dm.invisibleToUser) {
                        dm.fieldValue[0].value = "";
                    }
                    return dm;
                });
            }
            this.resetAllFilters();
            this.canBeSaved = false;
            this.saveFilterState = false;
            this.showFilterName = false;
            this.checkName = false;
            if (this.pageType === "reports") {
                this.filterObject = {
                    search: "",
                    statusesMod: [],
                    instanceMod: [],
                    fromDateTime: "",
                    toDateTime: "",
                    activityMod: "",
                    priorityMod: [],
                    localDataModel: []
                };
                this.userFilterIds = [];
                this.groupFilterIds = [];
                this.usersGroupsMod = [];
                this.displayedFilters = this.displayedFilters.filter(elem => !elem.hasOwnProperty("className"));
            }
            setTimeout(() => {
                this.checkToSearchData(true);
            }, 0);
            this.$emit("dataModelSearchFilters");
            this.$root.$emit("clearFilters", true);

            const { path, fullPath } = this.$route;
            const checkMatchRoute = this.$router.match({ path, query: {} });

            if (fullPath !== checkMatchRoute.fullPath) {
                this.$router.replace({ query: {} });
            }
        },
        fieldSelection(item) {
            this.arrayDataModel = this.pageType === "searchPerspectives" && this.incomePerspectiveDataModelKeys.length
                ? item.filter(({ formatted }) => (!this.incomePerspectiveDataModelKeys.includes(formatted))) : item;
        },
        collapseSearch() {
            this.$emit("collapseSearch", true);
        },
        activitiesLoaded(data) {
            this.$emit("activitiesData", data);
            this.activityFromCall = [...data];
            if (this.diagramLoaded && this.activityToSelect) {
                this.activityToSelect = null;
                this.searchItems();
            }
        },
        getAllActivities(data) {
            this.inputAllActivities = data;
        },
        confirmData() {
            const invisibleDM = this.filterObject.localDataModel.filter(elem => elem.invisibleToUser);
            this.filterObject.localDataModel = this.filterObject.localDataModel.filter(elem => this.arrayDataModel
                .findIndex(value => value.formatted === elem.formatted) !== -1);
            const diff = this.arrayDataModel.filter(elem => this.filterObject.localDataModel.findIndex(value => value.formatted === elem.formatted) === -1);
            this.filterObject.localDataModel = [...this.filterObject.localDataModel, ...diff];
            this.filterObject.localDataModel = this.filterObject.localDataModel.map(elem => {
                let paramsToReturn = {};
                if (elem.hasOwnProperty("key")) {
                    const [className, label] = elem.key.split(".").splice(-2);
                    paramsToReturn = {
                        className,
                        fieldValue: [{
                            value: ""
                        }],
                        invisibleToUser: false,
                        label,
                        lockOperator: false,
                        operator: "EQUAL",
                        formatted: elem.formatted,
                        type: elem.node.attrType,
                        visible: true,
                        canBeDeleted: true
                    };
                } else {
                    paramsToReturn = {
                        className: elem.className,
                        fieldValue: [{
                            value: elem.fieldValue[0].value
                        }],
                        invisibleToUser: false,
                        label: elem.label,
                        lockOperator: false,
                        operator: elem.operator,
                        formatted: elem.formatted,
                        type: elem.type,
                        visible: true,
                        canBeDeleted: elem.canBeDeleted
                    };
                }
                return paramsToReturn;
            });
            this.filterObject.localDataModel = [...this.filterObject.localDataModel, ...invisibleDM];
            if (this.pageType === "searchPerspectives" && this.incomePerspectiveDataModel.length) {
                if (this.filterObject.localDataModel.length) {
                    const dataModelToAdd = [];
                    this.incomePerspectiveDataModel.forEach(elem => {
                        const dmExist = this.filterObject.localDataModel.find(el => (el.formatted === elem.formatted));
                        if (!dmExist) { dataModelToAdd.push(elem); }
                    });
                    this.filterObject.localDataModel = [...this.filterObject.localDataModel, ...dataModelToAdd];
                } else {
                    this.filterObject.localDataModel = [...this.filterObject.localDataModel, ...this.incomePerspectiveDataModel];
                }
            }
            const cleanFilters = this.displayedFilters
                .filter(filter => !filter.hasOwnProperty("className") || (filter.hasOwnProperty("className") && !filter.canBeDeleted));
            const addToFinal = this.filterObject.localDataModel.filter(elem => elem.canBeDeleted);
            this.displayedFilters = [...cleanFilters, ...addToFinal];
            this.$emit("dataModelSearchFilters", this.filterObject.localDataModel);
            this.cancelData();
        },
        cancelData() {
            this.showDataModel = false;
            this.$refs.popoverRef.hide();
        },
        fieldClasses(field) {
            return {
                "item-flex custom-short-width": !field.type,
                "width-process-instance": !field.type && field.value === "instanceStatus",
                "custom-long-width": field.value === "assignees",
                "custom-data-model-container": !!field.type
            };
        },
        deleteDMFilter(key) {
            const bigIndex = this.displayedFilters.findIndex(filter => filter.formatted === key);
            this.displayedFilters.splice(bigIndex, 1);

            const smallIndex = this.filterObject.localDataModel.findIndex(filter => filter.formatted === key);
            this.filterObject.localDataModel.splice(smallIndex, 1);

            this.$emit("dataModelSearchFilters", this.filterObject.localDataModel);
            this.selection.splice(smallIndex, 1);
            this.arrayDataModel.splice(smallIndex, 1);
        },
        openFiltersModal() {
            this.$emit("openSavedFilters");
            this.$refs.filterRef.hide();
        },
        dataModelFilterErrors(error) {
            this.dmFilterError = error;
        },
        openSaveInput() {
            if (!this.readonly) {
                this.saveFilterState = true;
                this.filterName = "";
                setTimeout(() => {
                    this.$refs.saveAsRef.$refs.AQInput.focus();
                }, 0);
            }
        },
        cancelSaveAsState() {
            this.saveFilterState = false;
        },
        saveFilterName() {
            this.emptyFilterName = !this.filterName;
            if (!this.emptyFilterName) {
                this.dataToSend();
                this.saveFilterObj.name = this.filterName;
                this.saveFilterObj.searchModel = this.payload;
                delete this.saveFilterObj.searchModel.page;
                delete this.saveFilterObj.searchModel.size;
                const payload = {
                    interfaceData: this.saveFilterObj,
                    processDefinitionId: this.selectedProcess.id,
                    perspectiveCase: this.pageType === "searchPerspectives",
                    perspectiveId: this.getPerspectiveId,
                    appId: this.getCurrentApplicationId
                };
                this.saveReportsFilter(payload).then(
                    data => {
                        if (data.status) {
                            this.saveFilterState = false;
                            this.canBeSaved = false;
                            this.showFilterName = true;
                            this.savedfilterName = this.filterName;
                            this.filterSavedId = data.data.id;
                            this.$toast.showNotify({
                                type: "success",
                                message: this.$t("dashboard.filterSavedMessage")
                            });
                        } else {
                            this.duplicateName = true;
                        }
                    }
                )
                    .catch(() => {
                        this.duplicateName = true;
                    });
            }
        },
        removeErrors() {
            this.duplicateName = false;
            this.emptyFilterName = false;
        },
        searchTasksAndInstances(data) {
            if (!this.isOpened) {
                this.$emit("openSearchContainer", true);
            }
            this.filterObject.search = data;
            this.displayedFilters = this.displayedFilters.map(filter => {
                if (filter.value === "search") {
                    filter.fieldValue[0].value = data;
                }
                return filter;
            });
            this.temporaryPayload.searchTerm = data;
            this.$emit("resetDiagramStatus", this.temporaryPayload);
        }
    }
};
